import { render, staticRenderFns } from "./CandidatePublicCouncilCreate.vue?vue&type=template&id=4d0bd056&scoped=true&"
import script from "./CandidatePublicCouncilCreate.vue?vue&type=script&lang=js&"
export * from "./CandidatePublicCouncilCreate.vue?vue&type=script&lang=js&"
import style0 from "./CandidatePublicCouncilCreate.vue?vue&type=style&index=0&id=4d0bd056&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0bd056",
  null
  
)

export default component.exports